// extracted by mini-css-extract-plugin
module.exports = {"temoignages":"_2a1SFCIDmZnGzDxnSoN_Nj","paragraph":"xn1zdFpEjhGYpTHvSMpd3","carousel":"ogOv25mFcfNI142D7_UzQ"};